import React from 'react';

export default {
    SimpChn : {
        formTitle: "网上表格",
        
        steps_Application: "申请内容",

        steps_Particulars: "表格详情",
        
        field_CustomerTitle: "称谓",
        field_CustomerTitle_list: [
            {id: "CustomerTitle", value: "Mr", text: "先生"},
            {id: "CustomerTitle", value: "Mrs", text: "太太"},
            {id: "CustomerTitle", value: "Ms", text: "女士"},
            {id: "CustomerTitle", value: "Miss", text: "小姐"},
        ],
        
        field_CustomerLastName: "姓",

        field_CustomerFirstName: "名",

        field_TelephoneNo: "电话号码",

        field_EmailPostal: "电邮/邮寄地址",

        field_Message: "信息",

        field_Attachments_1: "附件1",

        field_Attachments_2: "附件2",

        field_Attachments_3: "附件3",

        acceptPrivacyPolicy: () => [<>我已阅读并同意土地註册处的<a href="http://www.landreg.gov.hk/chs/privacy.htm" target="_blank">私隐政策</a></>],

        Privacy: "私隐政策" ,

        notice_body: ()=> [
            <>
            
                <span>此表格内所有个人资料均予绝对保密，你的个人资料只会用作跟进用途。</span><br/>
            </>
            ]
            
        ,

        privacyPolicy_body: ()=> [
            <>
            
                <p>土地注册处会确保所有透过本网页递交的个人资料，均按照<a href="http://www.pcpd.org.hk/tc_chi/data_privacy_law/ordinance_at_a_Glance/ordinance.html" target="_blank">《个人资料(私隐)条例》</a>的有关条文处理。</p>
                <p>土地注册处会记录使用者浏览本网页的次数，但并不会收集任何足以辨识使用者身分的资料。所收集的浏览次数纪录只会用于制作统计报告及调查电脑系统问题，以助土地注册处改善本网页和服务。</p>
                <p>土地注册处可能会于不同期间及为个别原因，邀请你自愿提供个人资料。此等资料可能包括姓名、年龄、教育程度、职业、电话号码、邮寄地址或电邮地址。土地注册处邀请你提供资料时，会列明收集资料的目的和用途。</p>
                <p>除非法律许可或有所规定，土地注册处不会在未得到你的同意下透露你的个人资料予第三者。</p>
                <p>你向土地注册处网页提供的所有个人资料将予以保密，只供获得授权的人员查阅。</p>
                <p>本网页的搜寻服务是由一个政府的独立承办商提供。该独立承办商通知我们该公司于本网页提供搜寻结果时，不会收集可识别个人身分的资料。但该独立承办商会将你一些经由使用搜寻服务所得的匿名资料交予政府，作政府网站流量分析之用。政府不会从任何上述搜寻活动收集到的数据，跟任何 可能由政府持有的个人身分资料配对。</p>
            </>
            ]
            
        ,

        acknowledgement_para1: "本处将处理你已递交的表格。",

	    acknowledgement_para2: "如欲就是次表格作出查询，请提供以下参考编号。",

	    ack_refNum: "表格参考编号",
    }
}
    
    